import { render, staticRenderFns } from "./AgentPlate.vue?vue&type=template&id=5ad9c358&"
import script from "./AgentPlate.vue?vue&type=script&lang=ts&"
export * from "./AgentPlate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports